import { EntityLinks, Goal, ID } from '@griply/types';

import { getArchivedGoalIds } from '../derived-goal-state';
import { hasOpenTasks } from './has-open-tasks';

export type GetGoalTaskListGoalsOptions = {
  isGoalGrouping: boolean;
  links?: EntityLinks;
  taskCounts?: Map<ID, number>;
};

export const getGoalTaskListGoals = (
  goal: Goal | undefined,
  subGoals: Goal[],
  { isGoalGrouping, taskCounts, links }: GetGoalTaskListGoalsOptions,
): Goal[] => {
  if (!goal) {
    return [];
  }

  // Resolved over the sub-goals only: an archived focal goal keeps showing its own sub-goals.
  const archivedIds = isGoalGrouping
    ? getArchivedGoalIds(subGoals, { links })
    : new Set<ID>();

  const visibleSubGoals = subGoals.filter(
    (subGoal) =>
      !(
        isGoalGrouping &&
        (archivedIds.has(subGoal.id) ||
          (goal.hideCompletedTasks &&
            !!subGoal.completedAt &&
            !hasOpenTasks(subGoal.id, taskCounts)))
      ),
  );

  const goalSorting = goal.goalSorting;
  if (goalSorting?.length) {
    visibleSubGoals.sort(
      (a, b) =>
        (goalSorting.indexOf(a.id) + 1 || Number.MAX_VALUE) -
        (goalSorting.indexOf(b.id) + 1 || Number.MAX_VALUE),
    );
  }

  return [goal, ...visibleSubGoals];
};
